import { Currency } from "../models/Currency";

// TODO: resolve currency
export const resolveCurrency = (code: string): Currency => {
  const currencies = getCurrencies();
  const c = currencies.find((c) => c.code === code);
  return c || currencies[0];
};

export const getCurrencies = (): Currency[] => {
  return [
    {
      code: "AUD",
      symbol: "$",
      name: "AU Dollar",
    },
    {
      code: "USD",
      symbol: "$",
      name: "US Dollar",
    },
    // {
    //   code: "EUR",
    //   symbol: "€",
    //   name: "Euro",
    // },
  ];
};
